import { createAction } from '@mews/framework/redux';
import { Optional } from '@mews/std';

export const REPLACE_STATE_URL = 'REPLACE_STATE_URL';
export const replaceStateUrl = (url: Optional<string>) => createAction(REPLACE_STATE_URL, { url });
